import { useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { moveConfluenceArticle } from '../api';
import { Confluence } from '../interfaces';

function useMoveArticle(article: Confluence.IArticle | null, onMove?: (article: Confluence.IArticle) => void) {
  const [{ error, loading }, setData] = useState<{
    loading: boolean;
    error: boolean;
  }>({ loading: false, error: false });

  const { enqueueSnackbar } = useSnackbar();

  async function handleMoveArticle(parentId?: number, section?: Confluence.ESections) {
    if (!article?.id) return;

    try {
      setData((prevState) => ({ ...prevState, loading: true }));

      await moveConfluenceArticle(article?.id, parentId ?? null, section);

      setData((prevState) => ({ ...prevState, loading: false }));
      enqueueSnackbar('Статья успешно перемещена', { variant: 'success' });
      if (onMove) onMove(article);
    } catch (error) {
      setData({ loading: false, error: true });
      enqueueSnackbar((error as AxiosError).response?.data.message, { variant: 'error' });
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { loading, error, handleMoveArticle };
}

export default useMoveArticle;
